/*
Loading 3rd party scripts on user interaction:

To load the 3rd party scripts we need to move them inside a function that listens to user interactions.

Here's an original script that loads the third party script like Google Analytics, which we need to convert:

 <script async src="https://www.googletagmanager.com/gtag/js?id=G-GQVTDSW26X""></script>

Converted to:
  const loadGA4 = () => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-GQVTDSW26X";

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", "G-GQVTDSW26X");
    };

    document.head.appendChild(script);
  };

*/

(() => {
  const loadTriplePixel = () => {
    window.TriplePixelData = {
      TripleName: "optiat-shop.myshopify.com",
      ver: "2.11",
      plat: "SHOPIFY",
      isHeadless: false,
    };

    (function (W, H, A, L, E, _, B, N) {
      function O(U, T, P, H, R) {
        R = R || false;
        H = new XMLHttpRequest();
        if (P) {
          H.open("POST", U, true);
          H.setRequestHeader("Content-Type", "application/json");
        } else {
          H.open("GET", U, true);
        }
        H.send(JSON.stringify(P || {}));
        H.onreadystatechange = function () {
          if (H.readyState === 4) {
            if (H.status >= 200 && H.status < 300) {
              R = H.responseText;
              if (U.includes(".txt")) {
                eval(R);
              } else if (!P) {
                N[B] = R;
              }
            } else if (T && !R) {
              R = true;
              O(U, T - 1, P);
            }
          }
        };
      }

      if (!(N = window)[H + "sn"]) {
        N[H + "sn"] = 1;
        L = function () {
          return Date.now().toString(36) + "_" + Math.random().toString(36);
        };

        try {
          A.setItem(H, 1 + (parseInt(A.getItem(H), 10) || 0));
          E = JSON.parse(A.getItem(H + "U") || "[]");
          E.push({
            u: location.href,
            r: document.referrer,
            t: Date.now(),
            id: L(),
          });
          A.setItem(H + "U", JSON.stringify(E));
        } catch (e) {}

        if (!A.getItem('"!nC`')) {
          _ = A;
          A = N;

          if (!A[H]) {
            E = A[H] = function (t, e, a) {
              a = a || [];
              if (t === "State") return E.s;
              W = L();
              (E._q = E._q || []).push([W, t, e].concat(a));
              return W;
            };
            E.s = "Installed";
            E._q = [];
            E.ch = W;
          }

          B = "configSecurityConfModel";
          N[B] = 1;
          O("https://conf.config-security.com/model", 5);

          const i = L();
          const m = A[atob("c2NyZWVu")];

          _.setItem("di_pmt_wt", i);

          const p = {
            id: i,
            action: "profile",
            avatar: _.getItem("auth-security_rand_salt_"),
            time: m?.[atob("d2lkdGg=")] + ":" + m?.[atob("aGVpZ2h0")],
            host: A.TriplePixelData.TripleName,
            plat: A.TriplePixelData.plat,
            url: window.location.href,
            ref: document.referrer,
            ver: A.TriplePixelData.ver,
          };

          O("https://api.config-security.com/event", 5, p);
          O("https://whale.camera/live/dot.txt", 5);
        }
      }
    })("", "TriplePixel", localStorage);
  };

  const loadAdalyser = () => {
    (function (clientId) {
      if (window["__adal_disable_" + clientId]) {
        return;
      }

      (function (windowAlias, documentAlias, trackerName) {
        if (!windowAlias[trackerName]) {
          windowAlias.GlobalAdalyserNamespace =
            windowAlias.GlobalAdalyserNamespace || [];
          windowAlias.GlobalAdalyserNamespace.push(trackerName);

          windowAlias[trackerName] = function () {
            (windowAlias[trackerName].q =
              windowAlias[trackerName].q || []).push(arguments);
          };
          windowAlias[trackerName].q = windowAlias[trackerName].q || [];

          var nel = documentAlias.createElement("script"),
            fel = documentAlias.getElementsByTagName("script")[0];
          nel.async = 1;
          nel.src = "//c0.adalyser.com/adalyser.js?cid=" + clientId;
          fel.parentNode.insertBefore(nel, fel);
        }
      })(window, document, "adalyserTracker");

      window.adalyserTracker("create", {
        campaignCookieTimeout: 15552000,
        conversionCookieTimeout: 604800,
        clientId: clientId,
        trafficSourceInternalReferrers: ["^(.*\\.)?upcirclebeauty\\.com$"],
      });

      window.adalyserTracker("trackSession", "lce1");
    })("upcirclebeauty");
  };

  const loadHeatmap = () => {
    (function () {
      var _heatmap_paq = (window._heatmap_paq = window._heatmap_paq || []);
      var heatUrl = (window.heatUrl = "https://dashboard.heatmap.com/");

      function hLoadInitialScript(url) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.async = false;
        script.defer = true;
        document.head.appendChild(script);
      }

      hLoadInitialScript(heatUrl + "preprocessor.min.js?sid=303");

      window.addEventListener("DOMContentLoaded", function () {
        if (typeof _heatmap_paq !== "object" || _heatmap_paq.length === 0) {
          _heatmap_paq.push(["setTrackerUrl", heatUrl + "sttracker.php"]);
          hLoadInitialScript(heatUrl + "heatmap-light.min.js?sid=303");
        }
      });
    })();
  };

  const loadGTM = () => {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== "dataLayer" ? "&l=" + l : "";

      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;

      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-WGWJLMQ");
  };

  const loadGA4 = () => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-GQVTDSW26X";

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", "G-GQVTDSW26X");
    };

    document.head.appendChild(script);
  };

  const loadGAds107 = () => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-10790353823";

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", "AW-10790353823");
    };

    document.head.appendChild(script);
  };

  const loadGAds863 = () => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-863323343";

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", "AW-863323343");
    };

    document.head.appendChild(script);
  };

  const loadJunip = () => {
    const s = document.createElement("script");
    s.src =
      "https://scripts.juniphq.com/v1/junip_shopify.js?shop=optiat-shop.myshopify.com";
    s.async = true;
    document.body.appendChild(s);
  };

  const loadCookieScript = () => {
    const script = document.createElement("script");
    script.src =
      "https://cdn.cookie-script.com/s/4f59bea84e6e6b9ef4533a0a0c497582.js";
    script.setAttribute("charset", "UTF-8");
    document.head.appendChild(script);
  };

  const loadAfterpay = () => {
    const script = document.createElement("script");
    script.src = "https://static.afterpay.com/shopify-clearpay-javascript.js";
    script.async = true;
    document.head.appendChild(script);
  };

  const loadScripts = () => {
    loadTriplePixel();
    loadAdalyser();
    loadHeatmap();
    loadGTM();
    loadGA4();
    loadGAds107();
    loadGAds863();
    loadJunip();
    loadAfterpay();
    loadCookieScript();
  };

  document.addEventListener("UserInteracted", loadScripts, false);
})();
